import { colors, fonts } from '../../styles';

export const defaultCell = {
  root: {
    color: colors.gray.dark,
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.regular,
  },
};

export const descriptionCell = {
  root: {
    color: colors.gray.dark,
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.medium,
  },
};

export const blackDescriptionCell = {
  root: {
    color: colors.black,
    fontSize: fonts.size.small,
    fontWeight: fonts.weight.medium,
  },
};
